import { apiClient, unwrap } from '@services/api';
import type { Advertisement, ChartPoint, WholesalerOverview, WholesalerStats } from '@/types';

export const wholesalerService = {
  async getStats(): Promise<WholesalerStats> {
    const res = await apiClient.get<WholesalerStats>('/wholesaler/stats');
    return unwrap(res);
  },

  async getSalesChart(): Promise<ChartPoint[]> {
    const res = await apiClient.get<ChartPoint[]>('/wholesaler/stats/chart');
    return unwrap(res);
  },

  async getOverview(): Promise<WholesalerOverview> {
    const res = await apiClient.get<WholesalerOverview>('/wholesaler/overview');
    return unwrap(res);
  },

  async getAds(): Promise<Advertisement[]> {
    const res = await apiClient.get<Advertisement[]>('/wholesaler/ads');
    return unwrap(res);
  },

  async getAdPricing(): Promise<{ adCredits: number; creditsPerDay: number }> {
    const res = await apiClient.get<{ adCredits: number; creditsPerDay: number }>('/wholesaler/ad-pricing');
    return unwrap(res);
  },

  async requestAd(data: {
    title: string;
    subtitle?: string;
    image: string;
    buttonText?: string;
    buttonLink?: string;
    durationDays?: number;
    durationHours?: number;
  }): Promise<{ ad: Advertisement; creditsDeducted: number; adCredits: number }> {
    const res = await apiClient.post<{
      ad: Advertisement;
      creditsDeducted: number;
      adCredits: number;
    }>('/wholesaler/ad/request', data);
    return unwrap(res);
  },
};
